import React from "react";
import PropTypes from "prop-types";

// styles
import * as styles from "./DoctorCard.module.css";

const DoctorCard = ({ doctor, onClick }) => {
  return (
    <div
      className={styles.doctorCard}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyPress={e => {
        if (e.key === "Enter" || e.key === " ") {
          onClick();
        }
      }}
      aria-label={`View details for ${doctor.name}`}
    >
      <div
        className={styles.imageWrapper}
        style={{ backgroundColor: doctor.bgColor }}
      >
        <div className={styles.doctorImage}>{doctor.image}</div>
        <div className={styles.cardContent}>
          <h3 className={styles.doctorName}>{doctor.name}</h3>
          <p className={styles.experience}>{doctor.experience}</p>
          <p className={styles.credentials}>{doctor.credentials}</p>
        </div>
      </div>
    </div>
  );
};

DoctorCard.propTypes = {
  doctor: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    experience: PropTypes.string.isRequired,
    credentials: PropTypes.string.isRequired,
    bgColor: PropTypes.string.isRequired,
    image: PropTypes.node.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default DoctorCard;
